import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

export const MY_MUSIC = 'myMusic'
export const MUSIC_LIBRARY = 'musicLibrary'

export const MUSIC_TAB_CONTENT_TABBAR_DATA = [
  {
    name: 'musicLibrary',
    text: translate(T.MUSIC_LIBRARY_LABEL)
  },
  {
    name: 'myMusic',
    text: translate(T.MY_MUSIC_LABEL)
  }
]
